/* PBW Foundation theme — small progressive enhancements. Everything works without JS. */
(function () {
  'use strict';

  // Close other open dropdowns, and close on outside click / Escape.
  var navDetails = document.querySelectorAll('[data-nav-dropdown]');
  navDetails.forEach(function (el) {
    el.addEventListener('toggle', function () {
      if (!el.open) return;
      navDetails.forEach(function (other) { if (other !== el) other.removeAttribute('open'); });
    });
  });
  document.addEventListener('click', function (event) {
    navDetails.forEach(function (el) { if (el.open && !el.contains(event.target)) el.removeAttribute('open'); });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    navDetails.forEach(function (el) {
      if (el.open) { el.removeAttribute('open'); var s = el.querySelector('summary'); if (s) s.focus(); }
    });
    var drawer = document.querySelector('[data-menu-drawer]');
    if (drawer && drawer.open) { drawer.removeAttribute('open'); drawer.querySelector('summary').focus(); }
  });

  // Mobile drawer: lock page scroll and position under the header.
  var drawer = document.querySelector('[data-menu-drawer]');
  var header = document.querySelector('[data-site-header]');
  function setHeaderBottom() {
    if (!header) return;
    document.documentElement.style.setProperty('--header-bottom', header.getBoundingClientRect().bottom + 'px');
  }
  if (drawer) {
    drawer.addEventListener('toggle', function () {
      setHeaderBottom();
      document.body.classList.toggle('menu-open', drawer.open);
      drawer.querySelector('summary').setAttribute('aria-expanded', drawer.open ? 'true' : 'false');
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 1024 && drawer.open) drawer.removeAttribute('open');
    });
  }

  // Quantity steppers + live donation total.
  document.querySelectorAll('[data-quantity]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var form = wrap.closest('form');
    var totalEl = form ? form.querySelector('[data-donation-total]') : null;
    function update() {
      var q = Math.max(1, parseInt(input.value, 10) || 1);
      input.value = q;
      if (totalEl) {
        var unit = parseInt(totalEl.getAttribute('data-unit-price'), 10) || 0;
        var total = (unit * q) / 100;
        totalEl.textContent = '₹' + total.toLocaleString('en-IN', { maximumFractionDigits: 2 });
      }
    }
    wrap.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var q = parseInt(input.value, 10) || 1;
        input.value = btn.getAttribute('data-step') === 'up' ? q + 1 : Math.max(1, q - 1);
        update();
      });
    });
    input.addEventListener('change', update);
  });

  // Variant picker: keep the hidden variant id in sync with the selected options.
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var dataEl = picker.querySelector('script[type="application/json"]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var form = picker.closest('form');
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var button = form.querySelector('[data-add-button]');
    var totalEl = form.querySelector('[data-donation-total]');
    picker.addEventListener('change', function () {
      var selected = Array.prototype.map.call(picker.querySelectorAll('fieldset'), function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) priceEl.textContent = match.price_formatted;
      if (totalEl) { totalEl.setAttribute('data-unit-price', match.price); totalEl.dispatchEvent(new Event('refresh')); }
      if (button) { button.disabled = !match.available; }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
      var qty = form.querySelector('[data-quantity] input');
      if (qty) qty.dispatchEvent(new Event('change'));
    });
  });

  // Copy-link share button.
  document.querySelectorAll('[data-copy-link]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!navigator.clipboard) return;
      navigator.clipboard.writeText(btn.getAttribute('data-copy-link')).then(function () {
        var label = btn.querySelector('[data-copy-label]');
        if (!label) return;
        var old = label.textContent;
        label.textContent = btn.getAttribute('data-copied-text') || 'Copied';
        setTimeout(function () { label.textContent = old; }, 2000);
      });
    });
  });
})();
